import React, { useState, useContext, useEffect } from "react";
import styles from "./LoginRegistrate.module.css";
import Login from "../../components/login/Login";
import Registrate from "../../components/registrate/Registrate";
// import DownloadTheApplication from "../../components/downloadTheApplication/DownloadTheApplication";
import { ModalInfo } from "../../components/modalInfo/ModalInfo";
import Button from "../../components/ui/Button";
import CodeInput from "../../components/ui/CodeInput";

import { ProfileSvg, LetterSvg } from "../../img/Image";
import { UserContext } from "../../context/UserContext";
import { submitLogin, registrateUser, checkCode } from "./api";

function useScreenSize() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return { isMobile };
}

const WelcomContend = ({ welcomText, buttonText, onClick, isRegistration = false }) => {
  const { isMobile } = useScreenSize();
  return (
    <>
      {/* Шапка с иконкой профиля и названием */}
      <div className={styles.headerContainer}>
        <div
          className={styles.header}
          style={isRegistration ? { marginBottom: (isMobile ? "20px" : "40px")} : {marginBottom: "20px"}}
        >
          <div className={styles.profileIcon}>
            <ProfileSvg className={styles.profileImg} />
          </div>
          <div className={styles.titleWrapper}>
            <span className={styles.title}>ЛИЧНЫЙ КАБИНЕТ</span>
          </div>
        </div>
      </div>

      {/* Форма с приветствием */}
      <div className={styles.headerContainer}>
        <div className={styles.welcomeForm}>
          <div className={styles.welcomContend}>
            <h1
              className={styles.welcomeTitle}
              style={isRegistration
                ? { marginTop: isMobile ? "10px" : "50px" }
                : {}}
            >
              Добро пожаловать!
            </h1>
            <p
              className={styles.welcomeText}
              style={isRegistration
                ? { marginBottom: isMobile ? "20px" : "70px" }
                : {}}
            >
              {welcomText}
            </p>
            <div style={{
              marginBottom: isRegistration
                ? (isMobile ? "5px" : "95px")
                : (isMobile ? "5px" : "55px")
            }}>
              <Button label={buttonText} onClick={onClick} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const RegistrateComplete = ({ onClick, text, onResendCode, isCode }) => {
  const { isMobile } = useScreenSize();
  const [code, setCode] = useState("");
  const [timeLeft, setTimeLeft] = useState(60); // Таймер на 60 секунд
  const [canResend, setCanResend] = useState(false);
  const [error, setError] = useState(null); // Состояние для ошибки

  useEffect(() => {
    // Если таймер уже истек, ничего не делаем
    if (timeLeft <= 0) {
      setCanResend(true);
      return;
    }

    // Устанавливаем интервал для уменьшения таймера каждую секунду
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          setCanResend(true); // Устанавливаем canResend в true, когда время истекло
          clearInterval(timer); // Очищаем интервал
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Очищаем интервал при размонтировании
  }, [timeLeft]); // Зависимость только от timeLeft

  useEffect(() => {
    if (error) {
      setError(false);
    }
  }, [code]);

  const handleResendCode = () => {
    onResendCode();
    setTimeLeft(60); 
    setCanResend(false); 
    setError(null); 
  };

  const HandleButton = async () => {
    // Проверяем, что код полностью введен (4 цифры)
    if (code.length !== 4) {
      setError("Пожалуйста, введите полный код из 4 цифр");
      return;
    }

    const result = await onClick(code);
    if (result === false) {
      setError("Неверный код. Пожалуйста, попробуйте еще раз");
    } else {
      setError(null); // Очищаем ошибку, если код верный
    }
  };

  return (
    <div className={styles.containerRegistrateCompleted}>
      <div className={styles.headerContainer}>
        <div className={styles.header}>
          <div className={styles.profileIcon}>
            <ProfileSvg className={styles.profileImg} />
          </div>
          <div className={styles.titleWrapper}>
            <span className={styles.title}>ЛИЧНЫЙ КАБИНЕТ</span>
          </div>
        </div>
      </div>
      <div className={styles.headerContainer}>
        <div className={styles.blockInfo}>
          <div className={styles.welcomContendRegistrate}>
            <h1 className={styles.completeTitle}>{text}</h1>
            <div className={styles.letter}>
              <LetterSvg className={styles.letterImg} />
            </div>
            <p className={styles.completeText}>
              Вам на почту отправлено письмо с кодом для входа.
            </p>
            <div style={{ marginTop: isMobile ? "10px" : "20px", marginBottom: isMobile ? "10px" : "25px" }}>
              <CodeInput value={code} onChange={setCode} />
              {error && (
                <p className={styles.errorText} style={{ color: "red", marginTop: "10px", textAlign: "center", fontSize: "1rem" }}>
                  {error}
                </p>
              )}
            </div>
            <div style={{ marginBottom:  isMobile ? "10px" : "20px" }}>
              <Button label={"ВОЙТИ"} onClick={HandleButton} isSaving={isCode} isSavingLabel="ПРОВЕРЯЕМ КОД"/>
            </div>

            {/* Блок с таймером и кнопкой повторной отправки */}
            <div className={styles.resendCodeContainer}>
              {!canResend ? (
                <p className={styles.timerText}>
                  Запросить код повторно через: {timeLeft} сек.
                </p>
              ) : (
                <button
                  className={styles.resendButton}
                  onClick={handleResendCode}
                >
                  Запросить код снова
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.headerContainer} style={{ paddingTop: isMobile ? "20px" : "40px" }}>
        {/* <DownloadTheApplication /> */}
      </div>
    </div>
  );
};

const LoginRegistrate = () => {
  const [, setToken] = useContext(UserContext);

  const [authorization, setAuthorization] = useState(true);
  const [registrateCompleted, setRegistrateCompleted] = useState(false);
  const [textRegistrate, setTextRegistrate] = useState("Вы зарегистрировались в личном кабинете ВФТМ!");
  const [registrateData, setRegistrateData] = useState({});
  const [loginDetails, setLoginDetails] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [isRegistrate, setIsRegistrate] = useState(false);
  const [isCode, setIsCode] = useState(false);

  const handleButtonAuthorization = () => { setAuthorization(true) };
  const handleButtonRegistrate = () => { setAuthorization(false) };

  const HandleModalClickRegistrate = () => {
    setAuthorization(false);
    setIsModal(false);
  }

  const HandleModalClickLogin = () => {
    setAuthorization(true);
    setIsModal(false);
  }

  const PostLogin = async (email) => {
    const dataUser = { email: email };
    setRegistrateData(dataUser);
    setIsLogin(true);
    const login = await submitLogin(email);
    setIsLogin(false);
    if (login) {
      setLoginDetails(login)
      if (login.userWasCreated) {
        setRegistrateCompleted(true);
        setTextRegistrate("Авторизация в личном кабинете ВФТМ!")
      } else {
        setIsModal(true);
        setModalInfo("Пользователя с такой почтой нет, пожалуйста, создайте свою учетную запись");
      }

    }
  }

  const PostRegistrate = async (body) => {
    setRegistrateData(body);
    setIsRegistrate(true);
    const registrate = await registrateUser(body);
    setIsRegistrate(false);
    if (registrate) {
      setLoginDetails(registrate);
      if (registrate.userWasCreated) {
        setIsModal(true);
        setModalInfo("Пользователь с такой почтой уже зарегистрирован, пожалуйста, войдите в свою учетную запись");
      } else {
        setRegistrateCompleted(true);
        setTextRegistrate("Вы зарегистрировались в личном кабинете ВФТМ!")
      }
    }
  }

  const onResendCode = async () => {
    await PostLogin(registrateData.email);
  }

  const PostCheckCode = async (code) => {
    setIsCode(true);
    const result = await checkCode(registrateData, loginDetails, code, authorization);
    setIsCode(false);
    if (result) {
      if (result.isCodeCorrect) {
        const localJson = { token: true, userId: result.userID };
        setToken(localJson);
        setAuthorization(true);
        setRegistrateCompleted(false);
        return true;
      } else {
        return false;
      }
    }
  }


  return (
    <>
      {registrateCompleted ? (
        <div>
          <RegistrateComplete onClick={PostCheckCode} text={textRegistrate} authorization={authorization} onResendCode={onResendCode} isCode={isCode} />
        </div>
      ) : (
        <>
          <div className={styles.containerTwoBlock}>
            {authorization ? (
              <>
                <div className={styles.leftBlok}>
                  <WelcomContend welcomText={"Если Вы ещё не зарегистрированы, пожалуйста, создайте свою учетную запись"} buttonText={"РЕГИСТРАЦИЯ"} onClick={handleButtonRegistrate} />
                </div>
                <div className={styles.rightBlock}>
                  <Login handleLogin={PostLogin} isLogin={isLogin} />
                </div>
              </>
            ) : (
              <>
                <div className={styles.leftBlok}>
                  <WelcomContend welcomText={"Если у Вас уже есть аккаунт, пожалуйста, войдите в свою учетную запись"} buttonText={"ВОЙТИ"} onClick={handleButtonAuthorization} isRegistration={true} />
                </div>
                <div className={styles.rightBlock}>
                  <Registrate onClick={PostRegistrate} isRegistrate={isRegistrate} />
                </div>
              </>
            )}
          </div >
          <div className={styles.basement}>
            <div className={styles.leftBlok}>
              <div className={styles.headerContainer}>
                {/* <DownloadTheApplication /> */}
              </div>
            </div>
            <div className={styles.rightBlock}></div>
          </div>
        </>
      )}
      {isModal && (
        <>
          {authorization ? (
            <ModalInfo isModalOpen={isModal} setIsModalOpen={setIsModal} info={modalInfo} onClick={HandleModalClickRegistrate} labelButton={"РЕГИСТРАЦИЯ"} />
          ) : (
            <ModalInfo isModalOpen={isModal} setIsModalOpen={setIsModal} info={modalInfo} onClick={HandleModalClickLogin} labelButton={"ВОЙТИ"} />
          )}
        </>

      )}
    </>

  );
};

export default LoginRegistrate;